<h3 class="text-center text-[18px] mb-3">
  {{ "ADD_TO_COLLECTION" | translate }}
</h3>
@if (isSelectionBatch && selectedItemCount > 1) {
<p class="mb-2 text-center text-sm text-grey dark:text-borders-light">
  {{ "WORK_SELECTION_SELECTED_COUNT" | translate: {count: selectedItemCount} }}
</p>
} @if (!inModal) {
<button
  (click)="closeModalAddToList($event)"
  (keyup)="onKeyUp($event, 'closeModalAddToList')"
  tabindex="0"
  class="close"
>
  <span
    class="block w-[18px] h-[18px] mask-[url(/assets/images/icons/close.svg)] mask-size-[18px_18px] bg-black dark:bg-white mr-2"
  ></span>
</button>
}
<div class="form relative collection">
  <input
    [(ngModel)]="searchTerm"
    (ngModelChange)="onSearchTermChange()"
    class="search"
    type="text"
    placeholder="{{ 'SEARCH' | translate }}"
  />
  <span
    class="icon"
    style="
      -webkit-mask: url(&quot;/assets/images/icons/search.svg&quot;) center /
        24px 24px no-repeat;
      mask: url(&quot;/assets/images/icons/search.svg&quot;) center / 24px 24px
        no-repeat;
    "
  ></span>
  <button
    class="clear search-clear-action !top-[11px] !right-[11px] cursor-pointer opacity-0 transition-all duration-300 inline-block w-[18px] h-[18px] bg-black dark:bg-white -indent-[9999px]"
    style="
      -webkit-mask: url(&quot;/assets/images/icons/close.svg&quot;);
      mask: url(&quot;/assets/images/icons/close.svg&quot;);
      -webkit-mask-size: 18px 18px;
      mask-size: 18px 18px;
    "
    [ngClass]="{'opacity-100': isClearVisible}"
    (click)="clearSearch()"
    (keyup)="onKeyUp($event, 'clearSearch')"
    tabindex="0"
    type="button"
  >
    {{ "CLEAR_SEARCH" | translate }}
  </button>
</div>
<div class="add-to-list__lists overflow-y-auto max-h-[164px]">
  @if (isLoading) {
  <img
    src="./assets/images/loading.svg"
    alt="{{ 'LOADING' | translate }}"
    class="block w-[32px] h-[32px]"
  />
  } @else { @if (filteredLists && filteredLists.length > 0) { @for (list of
  filteredLists; track trackByFn($index, list)) {
  <div>
    <button
      class="relative block w-full py-[10px] pl-1 pr-8 text-left text-black dark:text-white disabled:text-black dark:disabled:text-white disabled:opacity-100 disabled:cursor-default cursor-pointer rounded-lg hover:bg-whitegrey dark:hover:bg-blackest"
      [ngClass]="{'in-list': isInList(list)}"
      [disabled]="isInList(list)"
      (click)="addToList($event, item, user, list)"
      (keyup)="onKeyUp($event, 'addToList', item, user, list)"
      tabindex="0"
    >
      {{ list.name }}
      @if (selectedItemCount > 1 && isPartiallyInList(list)) {
      <span
        class="ml-1 text-[12px] leading-[18px] italic text-grey dark:text-lightGrey"
        >{{ "WORK_SELECTION_SOME_IN_LIST" | translate }}</span
      >
      } @else if (selectedItemCount > 1 && isInList(list)) {
      <span
        class="all-in-list-label ml-1 text-[12px] leading-[18px] italic text-grey dark:text-lightGrey"
        >{{ "WORK_SELECTION_ALL_IN_LIST" | translate }}</span
      >
      }
    </button>
  </div>
  } } @else {
  <div class="mt-3 mb-4 italic">
    @if (lists.length > 0) {
    {{ "NO_RESULT_SEARCH" | translate }}
    } @else {
    {{ "NO_LIST_CREATED" | translate }}
    }
  </div>
  } }
</div>
<div class="relative h-[1px] bg-whitegrey dark:bg-borders-darker w-full my-3">
  <span
    class="absolute inline-block bg-white dark:bg-black-dark px-2 text-center -top-[11px] left-1/2 -translate-x-2/4"
    >{{ "OR" | translate }}</span
  >
</div>
<button
  class="btn text-center !text-[16px] m-auto mb-2"
  (click)="openModal('addList')"
  (keyup)="onKeyUp($event, 'addList')"
  tabindex="0"
>
  <span>{{ "CREATE_NEW_COLLECTION" | translate }}</span>
</button>
